import { gsap } from "gsap";

function animateOnVisible(element, animationFunction, once = true) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animationFunction();
          if (once) observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: "0px",
      threshold: 0.1,
    }
  );

  observer.observe(element);
}

document.addEventListener("DOMContentLoaded", () => {
  const banner = document.querySelector(".feedback-banner");
  if (!banner) return;

  const elements = gsap.utils
    .toArray([
      ".feedback-banner__inner h2",
      ".feedback-banner__inner__rating",
      ".feedback-banner__inner__stars",
      ".feedback-banner__inner__descr",
    ])
    .filter((el) => el);

  if (!elements.length) return;

  animateOnVisible(banner, () => {
    gsap.to(elements, {
      y: 0,
      opacity: 1,
      duration: 0.6,
      stagger: 0.15,
      ease: "power1.out",
    });
  });
});
